import {GetMeResponse} from '@backend-api/user/get-me.response';
import {createAction, props} from '@ngrx/store';

export const checkOnboarding = createAction('[Onboarding] check onboarding');
export const openOnboarding = createAction('[Onboarding] open onboarding');
export const closeOnboarding = createAction('[Onboarding] close onboarding');
export const closedOnboarding = createAction('[Onboarding] closed', props<{user: GetMeResponse}>());
